import React from 'react'

import { AcompanhamentoPreNatalContent } from './pre-natal/AcompanhamentoPreNatalContent'
import { ExternalPaths } from './pre-natal/model-acompanhamentoPreNatal'

interface AcompanhamentosContentProps {
  prontuarioId: ID
  atendimentoId: ID
  cidadaoId: ID
  dataReferencia: Instant
  externalPaths: ExternalPaths
  isVisualizacaoProntuario: boolean
}

export function AcompanhamentosContent(props: AcompanhamentosContentProps) {
  const { prontuarioId, atendimentoId, cidadaoId, dataReferencia, externalPaths, isVisualizacaoProntuario } = props

  return (
    <AcompanhamentoPreNatalContent
      prontuarioId={prontuarioId}
      atendimentoId={atendimentoId}
      cidadaoId={cidadaoId}
      dataReferencia={dataReferencia}
      externalPaths={externalPaths}
      isVisualizacaoProntuario={isVisualizacaoProntuario}
    />
  )
  //TODO (Royal Flush): Implementar Acompanhamento de Puerperio
}
